import { IShop } from '@dash.bar/types'
import { useCallback, useEffect } from 'react'
import api from '../../../../../widgets/shop/api'

import { ConversionsT } from '../../../../../types/widgetDataTypes/types'
import useApiData from '../../../../../hooks/api/useApiData'

const useConversion = ({ shop, interval }: { shop: IShop; interval: string }) => {
  const loadData = useCallback(async () => {
    const result: ConversionsT = await api(shop.endpoint, shop.secretToken, {
      body: {
        request: 'Analytics',
        widget: {
          conversion: {
            options: {
              active: true,
              details: false,
              interval,
            },
          },
        },
      },
      widget: 'conversion',
    })

    return result
  }, [shop, interval])

  const { getData, state } = useApiData(loadData)

  useEffect(() => {
    getData()
  }, [getData])

  return state
}

export default useConversion
